module.exports = __webpack_public_path__ + "img/Eventos_ver_formulario_red.1c93db1c.svg";